import {Link, Route, Routes, useParams} from 'react-router-dom';
import { NoticeList } from './NoticeList';
import { NoticeView }  from './NoticeView';

export const NoticePage = ()=>{
    const { school } = useParams();
    return (
        <div className="subpage">
            <div id="contents" className="bbs notice">
                <div className="sub_header">
                    <div className="inner">
                        <Link to={`/${school}/notice`}>
                            <div className="title_wrap"></div>
                        </Link>
                    </div>
                    <div className="sub_header_deco"></div>
                </div>
                <Routes>
                    <Route path="/" element={ <NoticeList /> } />
                    <Route path="/:id" element={ <NoticeView /> } />
                </Routes>
            </div>
        </div>
    );
};